import { Stack, Typography } from '@mui/material';

import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';

import { useDeleteProjectModal } from '../../hooks/useDeleteProjectModal';

export interface DeleteProjectModalProps {
  isError?: boolean;
  isSuccess?: boolean;
  ConfirmationStepComponent?: React.ReactNode;
}

export const DeleteProjectModal = () => {
  const {
    dialogMessages,
    contentMessages,
    hasCohorts,
    onClose,
    onSubmit,
    isSubmitting,
    isInitialLoading,
    deleteProjectError,
    saveButtonColor,
    isValidForSubmit,
  } = useDeleteProjectModal();

  return (
    <ApiWorkflowDialog
      id="deleteProjectModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      saveButtonColor={saveButtonColor}
      submittingError={deleteProjectError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      hideDisplayButtonsOnSuccess
    >
      <DialogMessageBox
        id="delete-project-message-box"
        title={contentMessages.confirmTitle}
        type="error"
        variant="outlined"
        renderSubmitted={
          !hasCohorts ? (
            <Stack gap={4}>
              <Typography color="error">{contentMessages.actionUndone}</Typography>
              <Typography>{contentMessages.description}</Typography>
            </Stack>
          ) : (
            <Typography>{contentMessages.deleteCohorts}</Typography>
          )
        }
      ></DialogMessageBox>
    </ApiWorkflowDialog>
  );
};
